import { render } from "./RfpDescription.vue?vue&type=template&id=0a94b3d6&scoped=true&ts=true"
import script from "./RfpDescription.vue?vue&type=script&lang=ts"
export * from "./RfpDescription.vue?vue&type=script&lang=ts"

import "./RfpDescription.vue?vue&type=style&index=0&id=0a94b3d6&lang=postcss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a94b3d6"]])

export default __exports__